import React, { useState, useEffect }  from 'react';
import { DataGrid } from '@mui/x-data-grid';
import CodiceVSVoceCliccabile3 from '../CodiceVSVoceCliccabile3';
import stileGrid from '../../interfaccia/stileGrid';

function ListaProdottiBrandDBperCreaProdNC({
  setProductFunction,
  listaProdottiBrand,
  utente,
  revisionaProdottiImportati
}) {

  const [rows,setRows] = useState(
    listaProdottiBrand
  )

  //PER IMPORT MODIFICA PRODOTTI
  //<ModificaProdottiNEW className="" prodotto={traduzione.prodottoCorrente} setProductFunction={setProductFunction} utente={autenticazione} listaNomiProdotto={listaNomiProdotto} />

  useEffect(() => {
    setRows(listaProdottiBrand)
  },[listaProdottiBrand]);

  const columns = [
    {
      field: 'brand',
      headerName: 'brand',
      width: 150,
    },
    {
      field: 'codVS',
      headerName: 'VS',
      width: 70,
      headerClassName: "b", // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      renderCell: (params) => {
        /* return <div className="rowitem">{params.row.codiceVS}</div>; */
        if (params.row.codVS) { return <CodiceVSVoceCliccabile3 
          codVS={params.row.codVS}
          codPS={params.row.codPS}
          codProd={params.row.codProd}
          shortName={params.row.shortName}
          tit={params.row.titIT}
          setProductFunction={setProductFunction} 
          utente={utente}
          imm={params.row.idImmaginePrincipale}
          /> } else { return <div className="rowitem">N/A</div> }
      }
    },
    {
      field: 'codPS',
      headerName: 'PS',
      width: 70,
    },
    !revisionaProdottiImportati && {
      field: 'stock',
      valueGetter: (params) => params.row.stock === "0" ? "❌" : params.row.stock,
      headerName: 'stock',
      width: 70
    },
    /* {
      field: 'idImmaginePrincipale',
      valueGetter: (params) => params.row.idImmaginePrincipale ? "✔️" : "❌",
      headerName: 'imm',
      width: 70
    }, */
    {
      field: 'codProd',
      valueGetter: (params) => params.row.codProd ?? "N/A",
      headerName: 'Cod Intero',
      headerClassName: 'b', // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      width: 250,
      renderCell: (params) => {
        if (params.row.codProd) { return <div className="rowitem">{params.row.codProd}</div>; } else { return <div className="rowitem">N/A</div> }
      }
    },
    /* {
      field: 'codiceProduttore.codProduttoreModello',
      valueGetter: (params) => params.row.codiceProduttore?.codProduttoreModello ?? "N/A",
      headerName: 'Cod Modello',
      headerClassName: 'fw7', // NON FUNZIONA, VIENE SOVRASCRITTO DA CLASSE .MuiDataGrid-columnHeaderTitle, MODIFICARE IN APP.CSS
      width: 200
    }, */
    {
      field: 'shortName',
      valueGetter: (params) => params.row.shortName ?? "N/A",
      headerName: 'SHORTNAME IT',
      width: 350
    },
    {
      field: 'titIT',
      //valueGetter: (params) => params.row.descrizioniSuPS?.titolo?.it ?? "N/A",

      headerName: 'Titolo',
      width: 350,
      renderCell: (params) => {
        if (params.row.titIT) { return <div className="rowitem">{params.row.titIT}</div>; } else { return <div className="rowitem">N/A</div> }
      }
    }
  ];

  return (
    <div
      className="colonna85vh"
    >
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.codVS}
        autoPageSize
        rowsPerPageOptions={[10, 20, 50]}
        pagination
        sx={stileGrid}
      />
      {utente.permessiAPI["update:database"] && <small>Clicca sul codiceVS (prima colonna) per modificare l'articolo</small>}
    </div>
  )
}


export default ListaProdottiBrandDBperCreaProdNC;
